import React from 'react';
import { styled } from '@mui/material/styles';
import MuiSwitch from '@mui/material/Switch';
import type { FormControlLabelProps } from '@mui/material/FormControlLabel';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import MuiListItemText from '@mui/material/ListItemText';

const FormControlLabel = styled(MuiFormControlLabel)(({ theme }) => ({
  gap: '8px',
  margin: '0px',
  '&:hover, &:focus': {
    '& .MuiSwitch-switchBase.Mui-checked': {
      '& + .MuiSwitch-track::before': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    '& .MuiSwitch-track::before': {
      backgroundColor: theme.palette.action.secondaryHover,
    },
  },
  '&.Mui-disabled': {
    '& .MuiTypography-root': {
      color: theme.palette.text.background.disabled,
    },
  },
}));

const ListItemText = styled(MuiListItemText)(({ theme }) => ({
  width: '204px',
  margin: '0px',
  '& .MuiListItemText-primary': {
    color: theme.palette.text.background.high,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: '19.6px',
    letterSpacing: '-0.14px',
  },
  '& .MuiListItemText-secondary': {
    color: theme.palette.text.background.medium,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '16.2px',
    letterSpacing: '-0.24px',
    '&:not(:first-child)': {
      marginTop: '2px',
    },
  },
}));

interface Props extends Omit<FormControlLabelProps, 'control' | 'label'> {
  helperText?: string;
  label?: string;
  customLabel?: React.ReactNode;
}

export default function Switch(props: Props) {
  const { helperText, customLabel, ...restProps } = props;

  return (
    <FormControlLabel
      {...restProps}
      labelPlacement="start"
      disableTypography
      control={<MuiSwitch />}
      label={
        customLabel || (props.label || helperText ? <ListItemText primary={props.label} secondary={helperText} /> : '')
      }
    />
  );
}
